import {Outlet} from 'react-router-dom';


import {
    FlexiSignInButton,
    PlatformAppShell,
    PlatformFooter,
    PlatformHeader,
    PlatformHeaderNavigationMenu,
    PlatformHeaderToolbar,
    PlatformLoader,
} from '@flexinet/ui-components';

import {
    ReactNode,
    Suspense
} from "react";
import {config} from "../config";
import {internalUrl} from "../lib/internalUrl";


export const AppLayout = () => {

    const menuItems = [] as { title: string, onClick: () => void }[]
    // menuItems.push({
    //                    title: 'Home',
    //                    onClick: () => navigate('/')
    //                })


    const additionalToolbarItems = [
        <FlexiSignInButton size={'xl'}
                           onClick={() => window.location.assign(internalUrl(config.platform.portal + '/sign-in', {campaign: 'header-signin'}))}/>
    ] as ReactNode[]

    const toolbar = <PlatformHeaderToolbar additionalToolbarItems={additionalToolbarItems}/>

    const header = <PlatformHeader
        navigationMenu={<PlatformHeaderNavigationMenu menuItems={menuItems}/>}
        toolbar={toolbar}
    />

    return <PlatformAppShell
        platformHeader={header}
        platformFooter={<PlatformFooter/>}
        header={{height: 80}}
        footer={{height: 100}}
        navbar={{
            width: 0,
            breakpoint: 'sm',
        }}
    >
        <Suspense fallback={<PlatformLoader/>}>
            <Outlet/>
        </Suspense>
    </PlatformAppShell>


};
